// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-cfb14424] .el-dialog__header{background:#1a243e;display:flex}.dialog_header[data-v-cfb14424]{display:flex;flex-direction:row;justify-content:space-between;align-items:center;flex:1;color:#fff}", ""]);
// Exports
module.exports = exports;
